import React, { useState } from "react";
import PropTypes from "prop-types";
import styles from "./BSMSearchItem.module.css";

/**
 * View component. Displays BSM item for search list.
 */
export function BSMSearchItem({ bsmItem, onAdd }) {
  return (
    <div className={styles.container}>
      <div className={styles.addBtn} onClick={() => onAdd(bsmItem)}>
        Add
      </div>
      <div className={styles.title}>
        {bsmItem.title} ({bsmItem.stockId})
      </div>
    </div>
  );
}

BSMSearchItem.propTypes = {
  /**
   * CMS item content.
   */
  bsmItem: PropTypes.string,
  /**
   * Function that fires when add is clicked.
   */
  onAdd: PropTypes.string,
};
